<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6">
            Créanciers
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              icon
              size="sm"
              variant="success"
              :to="{ path: '/creditor/new' }"
              title="nouveau créancier"
            >
              <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
            </b-button>
            <b-button
              icon
              size="sm"
              variant="info"
              :to="{ name: 'payments' }"
              class="ml-2"
              title="paiements en attente"
            >
              <b-icon-credit-card-fill></b-icon-credit-card-fill>
            </b-button>
            <b-button
              size="sm"
              variant="info"
              :to="{ name: 'purchaseOrder' }"
              class="ml-2"
              title="bon de commande"
            >
              <b-icon-pencil-square></b-icon-pencil-square>
            </b-button>
            <b-button
              v-if="$store.getters.isAdmin"
              size="sm"
              variant="info"
              class="ml-2"
              :href="export_no_account"
              target="_blank"
              title="Exporter les créanciers sans numéro de compte"
            >
              <b-icon-file-earmark-spreadsheet></b-icon-file-earmark-spreadsheet>
            </b-button>
            <label class="mx-3 align-self-center">Rechercher : </label>
            <mh-input
              @enter="submitSearch(searchTable.search.value, 'all')"
              append="🔍"
              field="search"
              autofocus
              :table="searchTable"
              :autocomplete="{
                idHistory: 'creditors',
                to: { name: 'creditorEdit' },
                field:
                  'creancier.nom_soc || creancier.address1 || creancier.address2 || creancier.codepostal || creancier.email',
              }"
            ></mh-input>
            <label class="mx-3 align-self-center">Par numéro : </label>
            <mh-input
              @enter="submitSearch(searchTable.byID.value, 'ID')"
              append="🔍"
              field="byID"
              :table="searchTable"
              :autocomplete="{
                idHistory: 'creditors',
                to: { name: 'creditorEdit' },
                field: 'creancier.ID',
              }"
            ></mh-input>
            <label class="mx-3 align-self-center">Par qualité : </label>
            <mh-input
              @enter="submitSearch(searchTable.byQuality.value, 'quality')"
              append="🔍"
              field="byQuality"
              :table="searchTable"
              :autocomplete="{
                idHistory: 'creditors',
                field: 'creancier.qualiteFR',
              }"
            ></mh-input>
            <label class="mx-3 align-self-center">Par code postal : </label>
            <mh-input
              @enter="
                submitSearch(searchTable.byPostalcode.value, 'postalcode')
              "
              append="🔍"
              field="byPostalcode"
              :table="searchTable"
              :autocomplete="{
                idHistory: 'creditors',
                field: 'creancier.codepostal',
              }"
            ></mh-input>
          </div>

          <b-row v-if="$options.creditors.length > 0">
            <b-col lg="12">
              <div class="table-responsive">
                <table class="table table-striped table-sm" style="">
                  <thead>
                    <tr>
                      <th style="width: 100px">#</th>
                      <th>Nom</th>
                      <th>Adresse</th>
                      <th>Téléphone</th>
                      <th>Email</th>
                      <th>À l'agenda</th>
                      <th style="width: 150px" class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(creditor, index) in $options.creditors"
                      :key="index"
                    >
                      <td>
                        <router-link
                          :to="{
                            name: 'creditorEdit',
                            params: { id: creditor.ID },
                          }"
                          >{{ creditor.ID }}</router-link
                        >
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'creditorEdit',
                            params: { id: creditor.ID },
                          }"
                          ><span v-html="company(creditor.nom_soc)"></span
                          ><span
                            class="ml-3"
                            v-html="fullName(creditor.prenom, creditor.nom)"
                          ></span
                        ></router-link>
                      </td>
                      <td>
                        {{
                          creditor.address1 +
                          (" " + creditor.address2).trim() +
                          ", " +
                          creditor.codepostal +
                          " " +
                          ucfirst(creditor.localite)
                        }}
                      </td>
                      <td>
                        {{ creditor.telephone }}
                      </td>
                      <td>
                        <template v-if="creditor.email !== null">
                          <span
                            v-for="(mail, index) in creditor.email.split(';')"
                            :key="index"
                          >
                            <b-link
                              class="mr-2"
                              active
                              target="_blank"
                              :href="'mailto:' + mail"
                            >
                              {{ mail.toLowerCase() }}
                            </b-link>
                          </span>
                        </template>
                      </td>
                      <td style="width:150px">
                        <template v-if="creditor.agenda !== null">
                          {{ toDate(creditor.agenda) }}
                        </template>
                      </td>
                      <td style="width: 150px" class="text-center">
                        <b-button
                          :to="{
                            name: 'creditorView',
                            params: {
                              id: creditor.ID,
                              options: { tab: 'mandats' },
                            },
                          }"
                          title="Liste des mandats"
                          size="sm"
                          icon
                          variant="info"
                          class="mr-2 btn-xs"
                        >
                          <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                        <b-button
                          :to="{
                            name: 'creditorView',
                            params: {
                              id: creditor.ID,
                              options: { tab: 'activite' },
                            },
                          }"
                          title="Payements en attente"
                          size="sm"
                          icon
                          variant="info"
                          class="mr-2 btn-xs"
                        >
                          <b-icon-clock-fill></b-icon-clock-fill>
                        </b-button>
                        <b-button
                          v-if="$store.getters.isSuperAdmin && creditor.age == 'current'"
                          title="désactiver"
                          size="sm"
                          class="btn-xs"
                          icon
                          variant="danger"
                          @click="toggleAge(creditor.ID)"
                        >
                          <b-icon-x-circle-fill></b-icon-x-circle-fill>
                        </b-button>
                        <b-button
                          title="réactiver"
                          v-else-if="$store.getters.isSuperAdmin && creditor.age == 'old'"
                          size="sm"
                          variant="success"
                          icon
                          class="btn-xs"
                          @click="toggleAge(creditor.ID)"
                        >
                          <b-icon-check-circle-fill></b-icon-check-circle-fill>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row v-else-if="loaded" class="mt-3">
            <b-col lg="12">
              <b-alert show>Pas de résultats</b-alert>
            </b-col>
          </b-row>
          <b-row v-if="$options.inactive_creditors.length > 0">
            <b-col lg="12" class="table-responsive">
              <h6>Créanciers inactifs</h6>
              <div class="table-responsive-sm">
                <table class="table table-striped table-sm" style="width: 100%">
                  <thead>
                    <tr>
                      <th style="width: 100px">#</th>
                      <th>Nom</th>
                      <th>Adresse</th>
                      <th>Téléphone</th>
                      <th>Email</th>
                      <th style="width: 150px" class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(creditor, index) in $options.inactive_creditors"
                      :key="index"
                    >
                      <td>
                        <router-link
                          :to="{
                            name: 'creditorEdit',
                            params: { id: creditor.ID },
                          }"
                          >{{ creditor.ID }}</router-link
                        >
                      </td>
                      <td>
                        <router-link
                          :to="{
                            name: 'creditorEdit',
                            params: { id: creditor.ID },
                          }"
                          ><span v-html="company(creditor.nom_soc)"></span
                          ><span
                            class="ml-3"
                            v-html="fullName(creditor.prenom, creditor.nom)"
                          ></span
                        ></router-link>
                      </td>
                      <td>
                        {{
                          creditor.address1 +
                          (" " + creditor.address2).trim() +
                          ", " +
                          creditor.codepostal +
                          " " +
                          ucfirst(creditor.localite)
                        }}
                      </td>
                      <td>
                        {{ creditor.telephone }}
                      </td>
                      <td>
                        <template v-if="creditor.email !== null">
                          <span
                            v-for="(mail, index) in creditor.email.split(';')"
                            :key="index"
                          >
                            <b-link
                              class="mr-2"
                              active
                              target="_blank"
                              :href="'mailto:' + mail"
                            >
                              {{ mail.toLowerCase() }}
                            </b-link>
                          </span>
                        </template>
                      </td>
                      <td style="width: 150px" class="text-center">
                        <b-button
                          :to="{
                            name: 'creditorView',
                            params: {
                              id: creditor.ID,
                              options: { tab: 'mandats' },
                            },
                          }"
                          title="Liste des mandats"
                          size="sm"
                          icon
                          variant="info"
                          class="mr-2 btn-xs"
                        >
                          <b-icon-list-ul></b-icon-list-ul>
                        </b-button>
                        <b-button
                          :to="{
                            name: 'creditorView',
                            params: {
                              id: creditor.ID,
                              options: { tab: 'activite' },
                            },
                          }"
                          title="Paiements en attente"
                          size="sm"
                          icon
                          variant="info"
                          class="mr-2 btn-xs"
                        >
                          <b-icon-clock-fill></b-icon-clock-fill>
                        </b-button>
                        <b-button
                          title="désactiver"
                          v-if="creditor.age == 'current'"
                          size="sm"
                          class="btn-xs"
                          icon
                          variant="danger"
                          @click="toggleAge(creditor.ID)"
                        >
                          <b-icon-x-circle-fill></b-icon-x-circle-fill>
                        </b-button>
                        <b-button
                          title="réactiver"
                          v-else
                          size="sm"
                          variant="success"
                          icon
                          class="btn-xs"
                          @click="toggleAge(creditor.ID)"
                        >
                          <b-icon-check-circle-fill></b-icon-check-circle-fill>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import List from "@/components/List";
import creditors from "@/services/creditors.js";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Creditors",
  components: {
    MhInput,
  },
  creditors: [],
  inactive_creditors: [],
  data() {
    return {
      options_active: [
        {
          text: "Créanciers actifs",
          value: true,
        },
        {
          text: "Créanciers inactifs",
          value: false,
        },
      ],
      searchTable: {
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
        byID: {
          label: "",
          type: "int",
          value: "",
        },
        byQuality: {
          label: "",
          type: "varchar",
          value: "",
        },
        byPostalcode: {
          label: "",
          type: "varchar",
          value: "",
        },
      },
      debug: false,
      info: {},
      search: this.$route.params.search || "",
      field: "all",
      resultsInfo: false,
      activeCreditor: true,
      facets: [],
      filters: [],
      page: 1,
      pagination: {
        numberOfPages: 1,
      },
      loaded: false,
      sortBy: "nom_soc",
      sortDesc: false,
      busy: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Créanciers",
          active: true,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "#",
          thStyle: "width:100px",
          class: "text-right",
          sortable: true,
        },
        { key: "nom_soc", label: "Nom de société", sortable: true },
        { key: "name", label: "Nom", sortable: true },
        {
          key: "address",
          label: "Adresse",
          sortable: true,
          class: "text-right",
        },
        { key: "telephone", label: "Téléphone", sortable: false },
        { key: "mail", label: "Email", sortable: true },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width: 150px",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
  },
  computed: {
    export_no_account() {
      let url = this.$store.getters.url + "/creditors/no_account/export?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      return url;
    },
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    toggleAge(payload) {
      creditors.toggleAge(payload).then((response) => {
        this.$bvToast.toast(response.data.message, {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.submitSearch();
      });
    },
    toPath(entry, data) {
      if (typeof entry.to === "string") {
        return { name: entry.to, params: { id: data.item.ID } };
      } else if (typeof entry.to === "object") {
        return {
          name: entry.to.name,
          params: { id: data.item.ID, options: entry.to.params },
        };
      }

      return "";
    },
    highlight(str) {
      if (!this.search) {
        return str;
      }
      return str.replace(new RegExp(this.search, "gi"), (match) => {
        return '<span class="highlightText">' + match + "</span>";
      });
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },
    continueSearch() {
      this.busy = true;
      creditors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          true
        )
        .then((response) => {
          this.$options.creditors = this.$options.creditors.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
          if (this.pagination.numberOfPages == this.page) {
            this.submitSearchNonActive(this.search, this.field);
          }
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch(value = null, field = null) {
      this.page = 1;
      this.busy = true;
      if (value !== null) {
        this.search = value;
      }
      if (field !== null) {
        this.field = field;
      }
      creditors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          true
        )
        .then((response) => {
          this.$options.creditors = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.searchTable.search.value = "";
          this.searchTable.byID.value = "";
          this.searchTable.byQuality.value = "";
          this.searchTable.byPostalcode.value = "";
          this.loaded = true;
          this.busy = false;
          if (this.pagination.numberOfPages == this.page) {
            this.submitSearchNonActive(this.search, this.field);
          }
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearchNonActive(value = null, field = null) {
      this.busy = true;
      if (value !== null) {
        this.search = value;
      }
      if (field !== null) {
        this.field = field;
      }
      creditors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          false
        )
        .then((response) => {
          this.$options.inactive_creditors = response.data.results.records;
          console.log(this.$options.inactive_creditors);
          this.loaded = true;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>